// extracted by mini-css-extract-plugin
export var actions = "_w-0";
export var actionsContainer = "_w-7";
export var border = "_w-1";
export var childFullHeight = "_w-g";
export var collapse = "_w-2";
export var content = "_w-b";
export var contentChild = "_w-f";
export var fullscreen = "_w-d";
export var hasLeftRadius = "_w-l";
export var headerContainer = "_w-3";
export var headerRow = "_w-5";
export var hidePadding = "_w-c";
export var navCollapsedGap = "_w-m";
export var noScrollX = "_w-n";
export var noScrollY = "_w-o";
export var noTopPadding = "_w-j";
export var optOutTopPadding = "_w-e";
export var pageMain = "_w-k";
export var pageOuter = "_w-h";
export var pagePadding = "_w-8";
export var pageScroll = "_w-9";
export var profile = "_w-p";
export var profileContainer = "_w-q";
export var profileImage = "_w-r";
export var profileMain = "_w-s";
export var profileSubtitle = "_w-u";
export var profileTitle = "_w-t";
export var settingsSurface = "_w-a";
export var showLeftPadding = "_w-i";
export var tabsPortalSlot = "_w-6";
export var tabsWrapper = "_w-4";
export var title = "_w-v";